import { SurveyActivity } from './survey-activity';

export const EmailSurveyActivity = [
  SurveyActivity.SENT,
  SurveyActivity.OPENED,
  SurveyActivity.CLICKED,
  SurveyActivity.FEEDBACK,
];
